import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { TransactionReceiptEffects } from './transaction-receipt.effects';
import { ITransactionReceiptFeature } from './transaction-receipt.feature.state';
import { transactionReceiptReducer } from './transaction-receipt.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<ITransactionReceiptFeature>('transactionReceiptFeature'), transactionReceiptReducer),
    EffectsModule.forFeature([TransactionReceiptEffects]),
  ],
})
export class TransactionReceiptStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: TransactionReceiptStateModule
  ) {
    if (parentModule) {
      throw new Error('TransactionReceiptStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
